module.exports = __webpack_public_path__ + "img/bygga.af24744e.png";